import { __assign, __rest } from '../../_virtual/_tslib.js';
import React, { forwardRef, Children } from 'react';
import classnames from 'classnames';
import styles from './styles.css.js';

var Box = forwardRef(function (_a, ref) {
  var _b;

  var column = _a.column,
      wrap = _a.wrap,
      justify = _a.justify,
      items = _a.items,
      content = _a.content,
      _c = _a.spacing,
      spacing = _c === void 0 ? 'normal' : _c,
      className = _a.className,
      children = _a.children,
      props = _a.props; // Always include "flex", the spacing class,  and the custom class (if provided)

  var classes = classnames('flex', styles[spacing], className, (_b = {
    'flex-wrap': wrap,
    'flex-column': column
  }, _b["justify-" + justify] = !!justify, _b["items-" + items] = !!items, _b["content-" + content] = !!content, _b));
  return React.createElement("div", __assign({
    className: classes,
    ref: ref
  }, props), Children.map(children, function (child) {
    if (child && ( // Check if the child is a string or number before accessing ".type"
    typeof child === 'string' || typeof child === 'number' || // Child is a React element, but don't wrap BoxItem's or Fragments
    React.isValidElement(child) && !isBoxItem(child) && child.type !== fragmentElement.type)) {
      return React.createElement(BoxItem, null, child);
    } else {
      return child;
    }
  }));
});

function isBoxItem(child) {
  if (typeof child.type == 'function') {
    return 'BOX_CHILD_INTERNAL' in child.type || false;
  } else {
    return false;
  }
}

var BoxItem = function BoxItem(_a) {
  var _b;

  var className = _a.className,
      grow = _a.grow,
      shrink = _a.shrink,
      self = _a.self,
      rest = __rest(_a, ["className", "grow", "shrink", "self"]);

  var classes = classnames(styles.item, className, (_b = {}, _b["self-" + self] = !!self, _b));
  var style = {
    flexGrow: grow,
    flexShrink: shrink
  };
  return React.createElement("div", __assign({
    className: classes,
    style: style
  }, rest));
}; // create a marker field so that we can compare with child elements in the box.
// unfornately type comparison with === doesn't work in dev due to react hot loader
// and the instruction in https://github.com/gaearon/react-hot-loader#checking-element-types
// won't work because react hot loader is only a dev dependency


BoxItem.BOX_CHILD_INTERNAL = true;
Box.Item = BoxItem;
var fragmentElement = React.createElement(React.Fragment, null);

export default Box;
export { BoxItem };
//# sourceMappingURL=index.js.map
